import {TomSelectWrapper} from "../../Scalesoft.Shared.FrontEnd/Scripts/TomSelect/TomSelectWrapper";

export default class UserDataSelect {
    private localization: Localization;

    constructor(localization: Localization) {
        this.localization = localization;
    }

    public init(): void {
        const selects = jq("select.user-data-select");
        this.handleSelectChange(selects);
        this.localization.translateAsync("code-search-placeholder", "UserInput").then((value) => {
            const insuranceCompanySelectEl: JQuery<HTMLSelectElement> = $(".insurance-company-code-select");
            if (insuranceCompanySelectEl[0]) {
                const insuranceCompanySelect: TomSelectWrapper = new TomSelectWrapper(
                    window.localization,
                    insuranceCompanySelectEl[0],
                    {
                        plugins: {
                            dropdown_input: {},
                        },
                        items: [],
                    });
                insuranceCompanySelect.initializeTomSelect();
            }
        });
    }

    public handleSelectChange(selects: JQuery): void {
        selects.on("change", (e) => {
            const target = jq(e.currentTarget);
            const value = jq(target).val();

            let parent = target.parent();
            if (parent.hasClass("bootstrap-select")) {
                parent = parent.parent();
            }
            const hiddenInput = parent.find(".user-data-select-input");
            hiddenInput.val(value);
            hiddenInput.trigger("change");
        });
    }
}
